import { defineComponent as _defineComponent } from 'vue'
import { Offer } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import PromotionRowNew from '@/components/buybox-new/PromotionRowNew.vue';
import { computed, ref } from 'vue';
import { useUserAgent } from '@/helpers/composables/useUserAgent';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import BuyBoxFreeTrialSwiperOSContainer from './BuyBoxFreeTrialSwiperOSContainer.vue';
import { freeTrialSwiperRules, SwiperRule } from '@/helpers/promotion-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { UsePromotion } from '@/helpers/composables/usePromotion';
import { OfferLocation } from '@/helpers/offer-helper';
import {
	geoExperimentSwiperRules,
	geoSwiperCountriesOrder,
	GeoSwiperExpVariants,
} from '@/components/experiments/GeoSwiperExp';

interface ClickoutPayload {
	buyboxOffer: UsePromotion['promotionOffer'];
	offerLocation: OfferLocation.FREE_TRIAL;
	row: HTMLElement | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFreeTrialSwiperOS',
  props: {
    offers: null,
    title: null,
    geoSwiperExpVariant: null,
    geoLocationCountry: null
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	offers: Offer[];
	title: TitleDetail;
	geoSwiperExpVariant?: GeoSwiperExpVariants | null;
	geoLocationCountry?: string | null;
};





const { userBrowser } = useUserAgent();
const { country } = useLanguageStore();

const freeTrialSwiperActive = computed(() => {
	if (props.geoSwiperExpVariant) {
		return geoExperimentSwiperRules[props.geoSwiperExpVariant || ''] != null;
	}
	return freeTrialSwiperRules[country.value] != null;
});

const freeTrialSwiperConfig = computed<SwiperRule | null>(() => {
	if (props.geoSwiperExpVariant) {
		return geoExperimentSwiperRules[props.geoSwiperExpVariant ?? ''] ?? null;
	}
	return freeTrialSwiperRules[country.value] ?? null;
});

const swiperPackages = computed(() => freeTrialSwiperConfig.value?.packages ?? null);

const swipeIndex = ref(0);

const isShowOrSeason = computed(() => ['Show', 'Season'].includes(props.title.__typename));

const slideDelay = computed(() => freeTrialSwiperConfig.value?.slideDelay ?? 1500);

const swiperPackageId = computed(() => {
	if (freeTrialSwiperConfig.value == null) return null;

	const browserRule = freeTrialSwiperConfig.value.rules.find(rule =>
		rule.selectors.browsers.includes(userBrowser.value)
	);
	if (browserRule) return browserRule.package;

	return freeTrialSwiperConfig.value.default.package;
});

const swiperSlideToIndex = computed(() => {
	if (props.geoSwiperExpVariant === 'variant_2') {
		return Math.max(0, geoSwiperCountriesOrder.indexOf(props.geoLocationCountry ?? ''));
	}
	if (props.geoSwiperExpVariant === 'variant_1') {
		return Math.max(0, geoSwiperCountriesOrder.slice(0, 2).indexOf(props.geoLocationCountry ?? ''));
	}
	if (swiperPackages.value == null || swiperPackageId.value == null) return 0;

	return Math.max(0, swiperPackages.value.indexOf(swiperPackageId.value));
});

function getHardcodedFallbackOfferId(packageId: number, index: number) {
	if (props.geoSwiperExpVariant === 'variant_2' && getGeoLocationCountry(index) === 'CA') {
		return 119;
	}

	return packageId;
}

function getGeoLocationCountry(index: number) {
	if (!props.geoSwiperExpVariant || index === 0) {
		return undefined;
	}

	return props.geoSwiperExpVariant === 'variant_2' ? geoSwiperCountriesOrder[index] : 'GB';
}

function slideChange({
	direction,
	position,
	skipTracking,
	nonInteraction,
}: {
	direction: string;
	position: number;
	skipTracking: boolean;
	nonInteraction: boolean;
}) {
	swipeIndex.value = position;

	if (!skipTracking) {
		TrackingHelper.trackEvent('userinteraction', {
			action: 'swipe_clicked',
			label: direction,
			nonInteraction,
		});
	}
}

return { __sfc: true,props, userBrowser, country, freeTrialSwiperActive, freeTrialSwiperConfig, swiperPackages, swipeIndex, isShowOrSeason, slideDelay, swiperPackageId, swiperSlideToIndex, getHardcodedFallbackOfferId, getGeoLocationCountry, slideChange, PromotionRowNew, BuyBoxFreeTrialSwiperOSContainer }
}

})